import 'css-chunksrc/client/scenes/projectDetailsConfiguration/form/styles.scss';export default {
  "form": "_form_l2dm7_1",
  "group": "_group_l2dm7_5",
  "row": "_row_l2dm7_9",
  "label": "_label_l2dm7_19",
  "description": "_description_l2dm7_24",
  "roleSelection": "_roleSelection_l2dm7_28"
};